import { Directive, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { first } from 'rxjs/operators';
import { AccountContextService, StrategyStyleType } from '../services/account-context.service';
import { Account } from '../../../domain/account.domain';

@Directive({
  selector: '[tdWbAccountContext]'
})
export class AccountContextDirective implements OnInit, OnChanges {
  @Input() initAccountId: string;

  @Input('tdWbAccountContextType') strategyStyle: StrategyStyleType = 'default';
  @Input('tdWbAccountContextUpdate') accountContextUpdate: boolean;
  @Input('tdWbAccountContextGroupOverride') groupOverridesAccountContext: boolean;

  // Inputs/Outputs of account selector
  @Input() accounts: Array<Account>;
  @Input() account: Account;
  @Output() readonly accountChange: EventEmitter<Account> = new EventEmitter<Account>();

  constructor(private accountContextService: AccountContextService) {
  }

  ngOnInit(): void {
    this.initSelectedAccount();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.account !== undefined && changes.account.currentValue !== undefined) {
      this.storeAccountAndGroupId(changes.account.currentValue);
    }
  }

  private getSelectedAccountGroupId(): string {
    return this.accountContextService.getSelectedAccountGroupId();
  }

  private storeAccountAndGroupId(account: Account): void {
    if (this.accountContextUpdate && account !== undefined && account.id !== undefined && account.groupId !== undefined) {
      this.accountContextService.setSelectedAccountId(account.id, this.strategyStyle);
      this.accountContextService.setSelectedAccountGroupId(account.groupId);
    }
  }

  private initSelectedAccount(): void {
    this.accountContextService.resolveAccount(this.accounts, this.initAccountId, this.strategyStyle)
      .pipe(first())
      .subscribe((account: Account): void => {
        let selectedGroupId;
        if (account !== undefined) {
          if (this.groupOverridesAccountContext) {
            selectedGroupId = this.getSelectedAccountGroupId();
            if (account.groupId !== selectedGroupId) {
              account = this.accounts
                .reduceRight((previous: Account, current: Account): Account => {
                  const matchingGroupId = current.groupId === this.getSelectedAccountGroupId();
                  return matchingGroupId ? current : previous;
                }, this.accounts[0]);
            }
          }
          this.storeAccountAndGroupId(account);
          this.account = account;
          this.accountChange.emit(this.account);
        } else {
          // TODO vpopov do we need it?
          this.account = undefined;
        }
      });
  }
}
